import { type Configuration, LogLevel } from "@azure/msal-browser";
import { getEnv } from "../env";

export const msalConfig: Configuration = {
  auth: {
    clientId: getEnv("VITE_AZURE_AD_CLIENT_ID"),
    authority: `https://login.microsoftonline.com/${getEnv("VITE_AZURE_AD_TENANT_ID")}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Warning,
    },
  },
};

export const loginRequest = {
  scopes: ["openid", "profile", "email"],
};

export const graphScopes = {
  scopes: ["User.Read"],
};

/**
 * Pagina de retorno de las llamadas SILENCIOSAS (acquireTokenSilent, ssoSilent,
 * popups del widget): una pagina vacia que NO carga la app.
 *
 * El redirect de pagina completa (loginRedirect / acquireTokenRedirect) SI
 * vuelve a `redirectUri` = la raiz, porque es la app quien tiene que canjear el
 * `code`. Pero cuando el refresh token no vale (cierre de sesion en 365), MSAL
 * renueva en un iframe OCULTO que vuelve a esta pagina. Si esa pagina es la
 * raiz, Sonia entera arranca dentro del iframe, comparte el sessionStorage de
 * la pestaña y su MSAL "limpia la cache temporal": borra el candado de
 * interaccion en curso de la pagina principal mientras aun canjea su `code`.
 * Con el candado fuera, el fallback a redirect vuelve a navegar a Microsoft a
 * mitad del canje, y la pagina recarga con un `code` nuevo hasta que el canje
 * gana la carrera (2026-10-07, en local y en produccion).
 *
 * Tiene que estar registrada como redirect URI en la app de Entra: ya lo esta,
 * el widget la usa desde el principio.
 */
export const silentRedirectUri = `${window.location.origin}/blank.html`;
